import React, { useState } from 'react';
import { DoctorConsultation, backArrow } from '../../../../assets/images';
import { Link, useHistory } from 'react-router-dom/cjs/react-router-dom.min';

const QRCode = ({qr_code, alt_code, requestAuth}) => {
  const history = useHistory()
  const [code, setCode] = useState('')
  const [toggle, setToggle] = useState(true)
  const dataUrl = `data:image/svg+xml;base64,${btoa(qr_code)}`

  return (
    <div className='my-12'>
      <img src={backArrow} onClick={() => history.goBack()} className='mb-3.5 cursor-pointer'/>
      <h1 className='text-xl leading-8 text-gray-900 mb-0' style={{ fontFamily: 'PT Serif', fontWeight: 700 }}>Connect an Authenticator App</h1>
      <p className='text-base text-gray-600 mt-3 mr-20 mb-0 w-96'>
        Connect an authenticator app that generates verification codes. You can use the codes when we need to verify your identity.
      </p>
      <div className='text-base text-gray-600 my-8 ml-6 mr-40' style={{ width: '22rem' }}>
        <ol style={{ listStyleType: 'decimal', listStylePosition: 'outside' }} className=''>
          <li>Download and install an authenticator app on your mobile device.</li>
          <li>Use the app to scan this QR code.</li>
          <li>Enter the code generated by the app.</li>
        </ol>
      </div>
      <div className='flex flex-col' style={{marginLeft: '40px'}}>
        <div>{ toggle ? 
          <img src={dataUrl} alt="SVG" className='ml-8' style={{marginLeft: '40px'}} width={184} height={184} /> :
          <p className='mt-6 font-semibold tracking-wider text-lg'>{alt_code}</p> }
        </div>
      </div>
      <span className='mb-3 mt-8 w-96 text-gray-500 uppercase tracking-widest text-sm block'>Verification Code</span>
      <input
        id='verification-code'
        type='number'
        name='code'
        value={code}
        onChange={(e) => {setCode(e.target.value)}}
        className={
          'text-base caret-blue-600 text-gray-700 placeholder-gray-300 leading-4 font-semibold pl-4 border border-gray-200 rounded-md w-96 h-14 bg-gray-100 focus:bg-gray-100 focus:ring-0  focus:outline-none focus:border-gray-400'
        }
      />
      <button
        className='bg-blue-600 text-white w-96 py-4 rounded-md text-base mt-6 font-semibold hover:bg-blue-600 focus:outline-none'
        onClick={ () => requestAuth(code) }
      >
        Connect
      </button>
      <p
        onClick={() => {setToggle(!toggle)}}
        style={{marginLeft: toggle ? '117px' : '147px'}}
        className='mb-0 mt-6 text-blue-500 font-semibold text-sm cursor-pointer border-white border-b hover:text-blue-600 hover:underline'
        >
            { toggle ? "I Can't Scan the QR Code" : 'Scan a QR Code' }
          </p>
    </div>
  )

}

export default QRCode;